import { zFilterRestriction, ZObjectMenuLink } from "./ZMenuItem";

export const getFilterRestrictionQuery = (
  link: ZObjectMenuLink,
): Record<string, string> => {
  const { filterRestriction } = link;
  const safeParse = zFilterRestriction.safeParse(filterRestriction);
  return safeParse.success
    ? { filterRestriction: JSON.stringify(safeParse.data) }
    : {};
};
